import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import { IFundOrderTableSearchParams } from "src/Interfaces/manualInterfaces";
import { IStepFundOrderTableReport } from "src/Interfaces/stepInterfaces";
import { getStepFundOrderTable } from "src/Requests/stepRequests";

interface IProps {
  searchParam: IFundOrderTableSearchParams;
}

const StepFundOrderTable = ({ searchParam }: IProps) => (
  <TableTemplate<IFundOrderTableSearchParams, IStepFundOrderTableReport>
    refreshTableTime={5000}
    getDataTable={getStepFundOrderTable}
    withSort
    TableUI={({ reports, onAction, sortingType, setSortingType }) => (
      <CommonTableUI
        reports={reports}
        onAction={onAction}
        sortingType={sortingType}
        setSortingType={setSortingType}
        tableBoxClassName="max-h-[500px]"
      />
    )}
    searchParameters={searchParam}
    showPageSize
  />
);

export default StepFundOrderTable;
